module.exports = __webpack_public_path__ + "img/rule_03.c972095a.png";